import { iocNames } from "../iocNames";
import { useInject } from "./useInject";

export function useBasketStore() {
  return useInject(iocNames.basketStore);
}
